
import { getTemplate1HTML } from './templates/template1';
import { getTemplate2HTML } from './templates/template2';
import { getTemplate3HTML } from './templates/template3';
import { getTemplate4HTML } from './templates/template4';
import { getTemplate5HTML } from './templates/template5';
import { getTemplate6HTML } from './templates/template6';

export const templateGenerators = {
    template1: getTemplate1HTML,
    template2: getTemplate2HTML,
    template3: getTemplate3HTML,
    template4: getTemplate4HTML,
    template5: getTemplate5HTML,
    template6: getTemplate6HTML,
};
